import message from 'antd/lib/message';

export function getBase64(file) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
    });
}
// upload，不需要ocr检测
export const uploadProps = {
    action: '/api/v1/image',
    name: 'image',
    data: {
        product_id: 'haoma',
        is_spot: 'NO'
    },
    accept: 'image/png, image/jpeg',
    credentials: 'include',
    listType: 'picture-card'
};

export function uploadPngOrJpg(file: {type: string, size: number}) {
    const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
    if (!isJpgOrPng) {
        message.error('图片仅支持jpg或png格式');
    }
    const isLt10M = file.size / 1024 / 1024 < 10;
    if (!isLt10M) {
        message.error('图片大小不超过10M');
    }
    return isJpgOrPng && isLt10M;
}
